import {Component} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {Language} from "../../../models/language";

@Component({
  selector: 'app-networking-made-effortless',
  templateUrl: './networking-made-effortless.component.html',
  styleUrls: ['./networking-made-effortless.component.scss', './networking-made-effortless-media.component.scss']
})
export class NetworkingMadeEffortlessComponent {

  currentLang: string = '';

  constructor(private translate: TranslateService) {
    this.translate.addLangs([Language.HY, Language.EN, Language.RU]);
    this.translate.setDefaultLang(Language.HY);
    this.currentLang = this.translate.currentLang || Language.HY;
    this.translate.onLangChange.subscribe((event) => {
      this.currentLang = event.lang;
    });
  }

  protected readonly Language = Language;
}
